import React, { Fragment } from 'react';

import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Tooltip from '@material-ui/core/Tooltip';
import DeleteIcon from '@material-ui/icons/DeleteOutlineOutlined';
import MaterialTable from 'material-table';
import { Paper } from '@material-ui/core'; 

import TruckCart from '../../models/TruckCart';
import TruckCartItem from '../../models/TruckCartItem';

import Moment from 'moment';

import truckCartStyles from './truckCart.module.css';
import style from '../cart/cart.module.css';
import commonStyles from '../common/common.module.css';

const iconFontSize = 20;
const styles = (theme: any) => ({

    materialIcon: {
      color: '#000',
      fontSize: iconFontSize,
      '&:hover': {
        cursor: 'pointer'
      },
      marginRight: 15
    },
    pickUpOrderButton: {
      padding: '3px 14px',
      border: '1px solid black'
    }
  });

interface TruckCartProps {
  classes: any;
  truckCart: TruckCart;
  deleteExportAwbFromCart: (awbCode: string, awbNumber: string) => void;
  handleGenerateDropOffOrder: () => void;
  disableButton: boolean;
};

const truckCart = (props: TruckCartProps) => {

  const { classes } = props;

  return (
    <Fragment>
      <div className= { `${ commonStyles.wrapper } ${truckCartStyles.wrapper}` }>
        <h3 className={ commonStyles.header }> AWB Details</h3>
        <MaterialTable

            components={{Container: props => <Paper {...props} elevation={0} className={ commonStyles.paperTable }/>}}

            data = { props.truckCart.cart }

            columns = {[
              { title: 'Airwaybill', cellStyle: { paddingTop: '16px' },
                render: (rowData: TruckCartItem) => { 

                  return <span>{ rowData.code }-{ rowData.number }</span>;
                }  
              },
              { title: 'Flight Number', cellStyle: { paddingTop: '16px' },
                render: (rowData: TruckCartItem) => { 
      
                  const flightDate: string = Moment(rowData.flight_date).format('DDMMMYY').toUpperCase();
                  const flightNumber: string = rowData.flight_no;
      
                  return <span>{`${flightNumber}/${flightDate}`}</span>;
                }
              },
              { title: 'Pcs', field: 'pieces', cellStyle: { paddingTop: '16px', textAlign: 'left' } },
              { title: 'Wgt', field: 'weight', cellStyle: { paddingTop: '16px', textAlign: 'left' },
                render: (rowData: TruckCartItem) => {

                  const weight: number = +(rowData.weight);
                  return <span>{ weight.toFixed(1) }K</span>;
                },  
              },
              { title: 'Action', headerStyle: { textAlign: 'center' },
                render: (rowData: TruckCartItem) => {

                  return <span className={ style.functionPanelStyle }>
                      <Tooltip title="Remove from group">
                        <DeleteIcon className={ classes.materialIcon } onClick={(events) => props.deleteExportAwbFromCart(rowData.code, rowData.number) } />
                      </Tooltip>
                    </span>;
                }
              }
          ]}
            
          options = {{
            selection: false,
            paging: false,
            pageSize: 10,
            headerStyle: {
              backgroundColor: 'var(--tbl_head_bkg)',
              color: 'var(--tbl_head_color)',
              zIndex: 2,
            },
            showTitle: false,
            pageSizeOptions: [15,20],
            toolbar: false,
            sorting: false,
            rowStyle: {
              verticalAlign: 'top'
            }
          }}
        />
      </div>
      <div className={ truckCartStyles.buttonWrapper }>
        <Button variant='contained' disabled={ props.disableButton } color='primary' className={ classes.pickUpOrderButton } onClick={ props.handleGenerateDropOffOrder }>
          Generate Drop Off Order
        </Button>
      </div>
    </Fragment>
  );
};

export default withStyles(styles)(truckCart);